module.exports = __webpack_public_path__ + "img/chinesecompany61.37604829.png";